import DeliveryInfo, { DeliveryInfoProps } from './DeliveryInfo';

export type { DeliveryInfoProps };
export default DeliveryInfo;
